import React from "react";
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  IconButton,
  Tooltip,
  CircularProgress,
  Box,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import BlockIcon from "@mui/icons-material/Block";
import DownloadIcon from "@mui/icons-material/Download";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#7e7e7e",
    color: theme.palette.common.white,
    textTransform: "capitalize",
    fontSize: 16,
    fontWeight: 600,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    textTransform: "capitalize",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd),&:nth-of-type(even)": {
    backgroundColor: theme.palette.action.hover,
    borderBottom: "1px solid rgba(224, 224, 224, 1)",
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const NotesPracticeModal = ({
  data,
  handleModalToggle,
  setSelectedRow,
  downloadQR,
  setSelectedPractice,
  setDisableModalOpen,
  loading
}) => {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(50);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleEdit = (row) => {
    setSelectedRow(row);
    handleModalToggle();
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleDisablePractice = (row) => {
    setSelectedPractice(row);
    setDisableModalOpen(true);
  };

  const paginatedRows = data?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <TableContainer component={Paper} className="table-container" sx={{ width: "100%", overflowX: "auto" }}>
      <Table sx={{ tableLayout: "auto", width: "max-content", minWidth: "100%" }} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell>Maker Plan</StyledTableCell>
            <StyledTableCell>Module</StyledTableCell>
            <StyledTableCell>Topic</StyledTableCell>
            <StyledTableCell>Day</StyledTableCell>
            <StyledTableCell>lab Strength</StyledTableCell>
            <StyledTableCell># Started</StyledTableCell>
            <StyledTableCell># Not Started</StyledTableCell>
            <StyledTableCell>Actions</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {loading ? (
            <TableRow>
              <StyledTableCell colSpan={7} align="center">
                <Box display="flex" justifyContent="center" alignItems="center" height="30px">
                  <CircularProgress />
                </Box>
              </StyledTableCell>
            </TableRow>
          ) :
            paginatedRows?.length > 0 ? (
              paginatedRows.map((row, index) => (
                <StyledTableRow key={index}>
                  <StyledTableCell>{row?.makerplan_name || "-"}</StyledTableCell>
                  <StyledTableCell>{row?.module_name || "-"}</StyledTableCell>
                  <StyledTableCell>{row?.topic_name || "-"}</StyledTableCell>
                  <StyledTableCell>{row?.note_name || "-"}</StyledTableCell>
                  <StyledTableCell>{row?.total_learners || 0}</StyledTableCell>
                  <StyledTableCell>{row?.total_learners_started || 0}</StyledTableCell>
                  <StyledTableCell>{row?.learners_not_started || 0}</StyledTableCell>
                  <StyledTableCell>
                    <Tooltip title="Edit" arrow onClick={() => handleEdit(row)}>
                      <IconButton size="small" aria-label="edit">
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Disable" arrow onClick={() => handleDisablePractice(row)}>
                      <IconButton size="small" aria-label="disable">
                        <BlockIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Download QR" arrow onClick={() => downloadQR(row)}>
                      <IconButton size="small" aria-label="Download QR">
                        <DownloadIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </StyledTableCell>
                </StyledTableRow>
              ))
            ) : (
              <StyledTableRow>
                <StyledTableCell sx={{ fontWeight: "600", color: "grey" }} colSpan={9} align="center">
                  No Practice notes found.
                </StyledTableCell>
              </StyledTableRow>
            )
          }
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[10,20,30,60,100]}
        component="div"
        count={data?.length || 0}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </TableContainer>
  );
};
export default NotesPracticeModal;
